import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import "react-image-lightbox/style.css";
import App from './App';
import * as serviceWorker from './serviceWorker';
ReactDOM.render(
// <script src="https://code.jquery.com/jquery-3.2.1.slim.min.js"></script>,
// <link rel="stylesheet" href="owl-carousel/owl.theme.css"/>,
    <App />, document.getElementById('root')
    );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
